export const constantNoMesin = [
  1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22,
  23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41,
  42, 43,
];

export const memoBahanBakuConstant = [
  {
    mesin: "1",
    customer: "",
    material: "",
    mold: "",
    color: "",
    total: 0,
    moldType: "",
  },
  {
    mesin: "2",
    customer: "",
    material: "",
    mold: "",
    color: "",
    total: 0,
    moldType: "",
  },
  {
    mesin: "3",
    customer: "",
    material: "",
    mold: "",
    color: "",
    total: 0,
    moldType: "",
  },
  {
    mesin: "4",
    customer: "",
    material: "",
    mold: "",
    color: "",
    total: 0,
    moldType: "",
  },
  {
    mesin: "5",
    customer: "",
    material: "",
    mold: "",
    color: "",
    total: 0,
    moldType: "",
  },
  {
    mesin: "6",
    customer: "",
    material: "",
    mold: "",
    color: "",
    total: 0,
    moldType: "",
  },
  {
    mesin: "7",
    customer: "",
    material: "",
    mold: "",
    color: "",
    total: 0,
    moldType: "",
  },
  {
    mesin: "8",
    customer: "",
    material: "",
    mold: "",
    color: "",
    total: 0,
    moldType: "",
  },
  {
    mesin: "9",
    customer: "",
    material: "",
    mold: "",
    color: "",
    total: 0,
    moldType: "",
  },
  {
    mesin: "10",
    customer: "",
    material: "",
    mold: "",
    color: "",
    total: 0,
    moldType: "",
  },
  {
    mesin: "11",
    customer: "",
    material: "",
    mold: "",
    color: "",
    total: 0,
    moldType: "",
  },
  {
    mesin: "12",
    customer: "",
    material: "",
    mold: "",
    color: "",
    total: 0,
    moldType: "",
  },
  {
    mesin: "13",
    customer: "",
    material: "",
    mold: "",
    color: "",
    total: 0,
    moldType: "",
  },
  {
    mesin: "14",
    customer: "",
    material: "",
    mold: "",
    color: "",
    total: 0,
    moldType: "",
  },
  {
    mesin: "15",
    customer: "",
    material: "",
    mold: "",
    color: "",
    total: 0,
    moldType: "",
  },
  {
    mesin: "16",
    customer: "",
    material: "",
    mold: "",
    color: "",
    total: 0,
    moldType: "",
  },
  {
    mesin: "17",
    customer: "",
    material: "",
    mold: "",
    color: "",
    total: 0,
    moldType: "",
  },
  {
    mesin: "18",
    customer: "",
    material: "",
    mold: "",
    color: "",
    total: 0,
    moldType: "",
  },
  {
    mesin: "19",
    customer: "",
    material: "",
    mold: "",
    color: "",
    total: 0,
    moldType: "",
  },
  {
    mesin: "20",
    customer: "",
    material: "",
    mold: "",
    color: "",
    total: 0,
    moldType: "",
  },
  {
    mesin: "21",
    customer: "",
    material: "",
    mold: "",
    color: "",
    total: 0,
    moldType: "",
  },
  {
    mesin: "22",
    customer: "",
    material: "",
    mold: "",
    color: "",
    total: 0,
    moldType: "",
  },
  {
    mesin: "23",
    customer: "",
    material: "",
    mold: "",
    color: "",
    total: 0,
    moldType: "",
  },
  {
    mesin: "24",
    customer: "",
    material: "",
    mold: "",
    color: "",
    total: 0,
    moldType: "",
  },
  {
    mesin: "25",
    customer: "",
    material: "",
    mold: "",
    color: "",
    total: 0,
    moldType: "",
  },
  {
    mesin: "26",
    customer: "",
    material: "",
    mold: "",
    color: "",
    total: 0,
    moldType: "",
  },
  {
    mesin: "27",
    customer: "",
    material: "",
    mold: "",
    color: "",
    total: 0,
    moldType: "",
  },
  {
    mesin: "28",
    customer: "",
    material: "",
    mold: "",
    color: "",
    total: 0,
    moldType: "",
  },
  {
    mesin: "29",
    customer: "",
    material: "",
    mold: "",
    color: "",
    total: 0,
    moldType: "",
  },
  {
    mesin: "30",
    customer: "",
    material: "",
    mold: "",
    color: "",
    total: 0,
    moldType: "",
  },
  {
    mesin: "31",
    customer: "",
    material: "",
    mold: "",
    color: "",
    total: 0,
    moldType: "",
  },
  {
    mesin: "32",
    customer: "",
    material: "",
    mold: "",
    color: "",
    total: 0,
    moldType: "",
  },
  {
    mesin: "33",
    customer: "",
    material: "",
    mold: "",
    color: "",
    total: 0,
    moldType: "",
  },
  {
    mesin: "34",
    customer: "",
    material: "",
    mold: "",
    color: "",
    total: 0,
    moldType: "",
  },
  {
    mesin: "35",
    customer: "",
    material: "",
    mold: "",
    color: "",
    total: 0,
    moldType: "",
  },
  {
    mesin: "36",
    customer: "",
    material: "",
    mold: "",
    color: "",
    total: 0,
    moldType: "",
  },
  {
    mesin: "37",
    customer: "",
    material: "",
    mold: "",
    color: "",
    total: 0,
    moldType: "",
  },
  {
    mesin: "38",
    customer: "",
    material: "",
    mold: "",
    color: "",
    total: 0,
    moldType: "",
  },
  {
    mesin: "39",
    customer: "",
    material: "",
    mold: "",
    color: "",
    total: 0,
    moldType: "",
  },
  {
    mesin: "40",
    customer: "",
    material: "",
    mold: "",
    color: "",
    total: 0,
    moldType: "",
  },
  {
    mesin: "41",
    customer: "",
    material: "",
    mold: "",
    color: "",
    total: 0,
    moldType: "",
  },
  {
    mesin: "42",
    customer: "",
    material: "",
    mold: "",
    color: "",
    total: 0,
    moldType: "",
  },
  {
    mesin: "43",
    customer: "",
    material: "",
    mold: "",
    color: "",
    total: 0,
    moldType: "",
  },
];

export const constantProduksi = {
  shift: "",
  date: "",
  data: [
    {
      mesin: "1",
      downtime: 0,
      totalGumpalan: 0,
    },
    {
      mesin: "2",
      downtime: 0,
      totalGumpalan: 0,
    },
    {
      mesin: "3",
      downtime: 0,
      totalGumpalan: 0,
    },
    {
      mesin: "4",
      downtime: 0,
      totalGumpalan: 0,
    },
    {
      mesin: "5",
      downtime: 0,
      totalGumpalan: 0,
    },
    {
      mesin: "6",
      downtime: 0,
      totalGumpalan: 0,
    },
    {
      mesin: "7",
      downtime: 0,
      totalGumpalan: 0,
    },
    {
      mesin: "8",
      downtime: 0,
      totalGumpalan: 0,
    },
    {
      mesin: "9",
      downtime: 0,
      totalGumpalan: 0,
    },
    {
      mesin: "10",
      downtime: 0,
      totalGumpalan: 0,
    },
    {
      mesin: "11",
      downtime: 0,
      totalGumpalan: 0,
    },
    {
      mesin: "12",
      downtime: 0,
      totalGumpalan: 0,
    },
    {
      mesin: "13",
      downtime: 0,
      totalGumpalan: 0,
    },
    {
      mesin: "14",
      downtime: 0,
      totalGumpalan: 0,
    },
    {
      mesin: "15",
      downtime: 0,
      totalGumpalan: 0,
    },
    {
      mesin: "16",
      downtime: 0,
      totalGumpalan: 0,
    },
    {
      mesin: "17",
      downtime: 0,
      totalGumpalan: 0,
    },
    {
      mesin: "18",
      downtime: 0,
      totalGumpalan: 0,
    },
    {
      mesin: "19",
      downtime: 0,
      totalGumpalan: 0,
    },
    {
      mesin: "20",
      downtime: 0,
      totalGumpalan: 0,
    },
    {
      mesin: "21",
      downtime: 0,
      totalGumpalan: 0,
    },
    {
      mesin: "22",
      downtime: 0,
      totalGumpalan: 0,
    },
    {
      mesin: "23",
      downtime: 0,
      totalGumpalan: 0,
    },
    {
      mesin: "24",
      downtime: 0,
      totalGumpalan: 0,
    },
    {
      mesin: "25",
      downtime: 0,
      totalGumpalan: 0,
    },
    {
      mesin: "26",
      downtime: 0,
      totalGumpalan: 0,
    },
    {
      mesin: "27",
      downtime: 0,
      totalGumpalan: 0,
    },
    {
      mesin: "28",
      downtime: 0,
      totalGumpalan: 0,
    },
    {
      mesin: "29",
      downtime: 0,
      totalGumpalan: 0,
    },
    {
      mesin: "30",
      downtime: 0,
      totalGumpalan: 0,
    },
    {
      mesin: "31",
      downtime: 0,
      totalGumpalan: 0,
    },
    {
      mesin: "32",
      downtime: 0,
      totalGumpalan: 0,
    },
    {
      mesin: "33",
      downtime: 0,
      totalGumpalan: 0,
    },
    {
      mesin: "34",
      downtime: 0,
      totalGumpalan: 0,
    },
    {
      mesin: "35",
      downtime: 0,
      totalGumpalan: 0,
    },
    {
      mesin: "36",
      downtime: 0,
      totalGumpalan: 0,
    },
    {
      mesin: "37",
      downtime: 0,
      totalGumpalan: 0,
    },
    {
      mesin: "38",
      downtime: 0,
      totalGumpalan: 0,
    },
    {
      mesin: "39",
      downtime: 0,
      totalGumpalan: 0,
    },
    {
      mesin: "40",
      downtime: 0,
      totalGumpalan: 0,
    },
    {
      mesin: "41",
      downtime: 0,
      totalGumpalan: 0,
    },
    {
      mesin: "42",
      downtime: 0,
      totalGumpalan: 0,
    },
    {
      mesin: "43",
      downtime: 0,
      totalGumpalan: 0,
    },
  ],
};

export const detailQc = [
  { cavity: 1, berat: "" },
  { cavity: 2, berat: "" },
  { cavity: 3, berat: "" },
  { cavity: 4, berat: "" },
  { cavity: 5, berat: "" },
  { cavity: 6, berat: "" },
  { cavity: 7, berat: "" },
  { cavity: 8, berat: "" },
  { cavity: 9, berat: "" },
  { cavity: 10, berat: "" },
  { cavity: 11, berat: "" },
  { cavity: 12, berat: "" },
  { cavity: 13, berat: "" },
  { cavity: 14, berat: "" },
  { cavity: 15, berat: "" },
  { cavity: 16, berat: "" },
  { cavity: 17, berat: "" },
  { cavity: 18, berat: "" },
  { cavity: 19, berat: "" },
  { cavity: 20, berat: "" },
  { cavity: 21, berat: "" },
  { cavity: 22, berat: "" },
  { cavity: 23, berat: "" },
  { cavity: 24, berat: "" },
];

export const pekerjaanPrinting = [
  { id: 1, jenisPekerjaan: "Print" },
  { id: 2, jenisPekerjaan: "Pasang Sticker" },
  { id: 3, jenisPekerjaan: "Punching" },
  { id: 4, jenisPekerjaan: "Sortir" },
];

export const pekerjaanSP = [
  { id: 1, jenisPekerjaan: "Filling Plug" },
  { id: 2, jenisPekerjaan: "Pasang Handle" },
  { id: 3, jenisPekerjaan: "Pemasangan BNW" },
  { id: 4, jenisPekerjaan: "Pemasangan Valve & Filter" },
  { id: 5, jenisPekerjaan: "Pemasangan Elbow" },
  { id: 6, jenisPekerjaan: "Pemasangan MF" },
  { id: 7, jenisPekerjaan: "Pemasangan Filter Arrestor" },
  { id: 8, jenisPekerjaan: "Putus Ronce" },
  { id: 9, jenisPekerjaan: "Sortir" },
  { id: 10, jenisPekerjaan: "Test Bocor" },
  { id: 11, jenisPekerjaan: "Test Cahaya" },
  { id: 12, jenisPekerjaan: "Ultrasonic" },
  { id: 13, jenisPekerjaan: "Marking" },
];

export const pekerjaanSPTim2 = [
  { id: 1, jenisPekerjaan: "Pasang Handle" },
  { id: 2, jenisPekerjaan: "Pemasangan Valve & Filter" },
  { id: 3, jenisPekerjaan: "Pemasangan Filter" },
  { id: 4, jenisPekerjaan: "Pemasangan Top Plate" },
  { id: 5, jenisPekerjaan: "Sortir" },
  { id: 6, jenisPekerjaan: "Test Bocor" },
  { id: 7, jenisPekerjaan: "Test Cahaya" },
  { id: 8, jenisPekerjaan: "Ultrasonic" },
  { id: 9, jenisPekerjaan: "Test Tarik" },
];

export const constWarnaPrinting = [
  "BLACK",
  "BLACK - ORANGE",
  "BLUE",
  "BLUE - RED",
  "GREEN",
  "GREEN - VIOLET",
  "YELLOW - WHITE",
  "NATURAL",
  "RED",
  "VIOLET",
  "VIOLET - PINK",
  "WHITE",
  "ORANGE",
];

export const constMesinSP = ["1", "2", "3", "4", "5", "6", "7", "8", "9", "10"];
export const constMesinSPTim2 = [
  "1A",
  "1B",
  "2A",
  "2B",
  "3A",
  "3B",
  "4A",
  "4B",
  "5A",
  "5B",
  "6A",
  "6B",
  "7A",
  "7B",
  "8A",
  "8B",
  "9A",
  "9B",
  "10A",
  "10B",
];

export const rejectSP = [
  { id: "1", desc: "Bergeser" },
  { id: "2", desc: "Bocor" },
  { id: "3", desc: "Cacat Kosmetik" },
  { id: "4", desc: "Deformasi" },
  { id: "5", desc: "Destruktif" },
  { id: "6", desc: "EX Bor" },
  { id: "7", desc: "Hangus" },
  { id: "8", desc: "Plate Ngambang" },
  { id: "9", desc: "Settingan" },
  { id: "10", desc: "Tanpa Karet" },
  { id: "11", desc: "Kusam" },

  { id: "12", desc: "Tanpa karet" },
  { id: "13", desc: "Karet Melintir" },
  { id: "14", desc: "Karet Tidak ke Dasar" },
  { id: "15", desc: "Karet Melejit" },
];

export const rejectSPTim2 = [
  { id: "1", desc: "Burning" },
  { id: "2", desc: "Crack" },
  { id: "3", desc: "Cacat Kosmetik" },
  { id: "4", desc: "Over Cut" },
  { id: "5", desc: "Handle Terangkat" },
  { id: "6", desc: "Deformasi" },
  { id: "7", desc: "Scratch" },
  { id: "8", desc: "Setting Awal" },
  { id: "9", desc: "Kusam" },
];
export const rejectPR = [
  { id: "1", desc: "Printing Meleber" },
  { id: "2", desc: "Printing Terkelupas" },
  { id: "3", desc: "Printing Miring" },
  { id: "4", desc: "Printing Geser" },
  { id: "5", desc: "Printing Tergores" },
  { id: "6", desc: "Printing Double" },
  { id: "7", desc: "Printing Tidak Sempurna" },
  { id: "8", desc: "Huruf Putus-Putus" },
  { id: "9", desc: "Huruf Mengecil" },
  { id: "10", desc: "Salah Printing" },
  { id: "11", desc: "Warna Printing" },
  { id: "12", desc: "Punching" },
  { id: "13", desc: "Setting Awal" },
];
export const rejectPRTim2 = [
  { id: "1", desc: "Setting Awal" },
  { id: "2", desc: "Printing beda warna" },
  { id: "3", desc: "Printing melebar" },
  { id: "4", desc: "Printing Putus-Putus" },
  { id: "5", desc: "Printing tidak rata" },
  { id: "6", desc: "Printing geser" },
  { id: "7", desc: "Printing double" },
  { id: "8", desc: "Huruf mengecil" },
  { id: "9", desc: "Printing Scratch" },
  { id: "10", desc: "Printing miring" },
  { id: "11", desc: "Printing Terkelupas" },
  { id: "12", desc: "Printing tidak lengkap" },
  { id: "13", desc: "Salah type printing" },
  { id: "14", desc: "Printing salah posisi" },
  { id: "15", desc: "Baret" },
  { id: "16", desc: "Deformasi" },
  { id: "17", desc: "Lubang tdk center" },
  { id: "18", desc: "Lubang berserabut" },
];

export const shiftTim1 = ["SUPRIADI", "ACHMAD S", "SARIPUDIN"];
export const shiftTim2 = ["QC 1", "QC 2", "QC 3"];

export const constCustomer = [
  "CBI",
  "GS",
  "MELCO",
  "TBP",
  "TIM",
  "YBI",
  "COMPOTEC",
];

export const constCustomerBox = [
  "CBI",
  "GSK",
  "MELCO",
  "TBP",
  "TIM",
  "YBI",
  "GSS",
];

export const jumlahHari = [
  1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22,
  23, 24, 25, 26, 27, 28, 29, 30, 31,
];

export const bulan = [
  { name: "Januari", value: 1 },
  { name: "Februari", value: 2 },
  { name: "Maret", value: 3 },
  { name: "April", value: 4 },
  { name: "Mei", value: 5 },
  { name: "Juni", value: 6 },
  { name: "Juli", value: 7 },
  { name: "Agustus", value: 8 },
  { name: "September", value: 9 },
  { name: "Oktober", value: 10 },
  { name: "November", value: 11 },
  { name: "Desember", value: 12 },
];
export const tahun = ["2022", "2023", "2024", "2025", "2026", "2027"];

export const barcodeSecurity = [
  "COOLING_TOWER_1",
  "COOLING_TOWER_2",
  "OFFICE_PRODUKSI",
  "RUANG_PRODUKSI",
  "GUDANG_TIMAH_CRUSHING",
  "GUDANG_BAHAN_BAKU",
  "FINISHING_GBJ",
  "Office Atas",
  "RUANG ATK",
  "BELAKANG_PABRIK",
  "PRINTING_BARU",
  "RUANGAN_MOLD_MESIN",
];

export const kepalaShiftTimOne = [
  { name: "ACHMAD", value: "ACHMAD" },
  { name: "SARIPUDIN", value: "SARIPUDIN" },
  { name: "SUPRIADI", value: "SUPRIADI" },
  { name: "DIDIN", value: "DIDIN" },
  { name: "MEI", value: "MEI" },
  { name: "NURDIANSYAH", value: "NURDIANSYAH" },
  { name: "MUJI", value: "MUJI" },
  { name: "HARIYADI", value: "HARIYADI" },
  { name: "WAWAN", value: "WAWAN" },
  { name: "ANTHONI", value: "ANTHONI" },
  { name: "DESY", value: "DESY" },
  { name: "MAYA", value: "MAYA" },
  { name: "KHANIFUDIN", value: "KHANIFUDIN" },
];

export const kepalaShiftTimTwo = [
  { name: "MAULANA", value: "MAULANA" },
  { name: "FINDRI", value: "FINDRI" },
  { name: "IMAM PRACOYO", value: "IMAM PRACOYO" },
  { name: "CHAIRUL", value: "CHAIRUL" },
  { name: "AISAH", value: "AISAH" },
  { name: "IQBAL", value: "IQBAL" },
  { name: "SUHENDAR", value: "SUHENDAR" },
  { name: "BUDI", value: "BUDI" },
  { name: "NAMIN", value: "NAMIN" },
  { name: "AZIZ", value: "AZIZ" },
  { name: "INDAH", value: "INDAH" },
  { name: "NOVI", value: "NOVI" },
];

export const clockJam = [
  { label: "00", value: "00" },
  { label: "01", value: "01" },
  { label: "02", value: "02" },
  { label: "03", value: "03" },
  { label: "04", value: "04" },
  { label: "05", value: "05" },
  { label: "06", value: "06" },
  { label: "07", value: "07" },
  { label: "08", value: "08" },
  { label: "09", value: "09" },
  { label: "10", value: "10" },
  { label: "11", value: "11" },
  { label: "12", value: "12" },
  { label: "13", value: "13" },
  { label: "14", value: "14" },
  { label: "15", value: "15" },
  { label: "16", value: "16" },
  { label: "18", value: "18" },
  { label: "19", value: "19" },
  { label: "20", value: "20" },
  { label: "21", value: "21" },
  { label: "22", value: "22" },
  { label: "23", value: "23" },
];

export const BagianConstant = [
  { name: "ADM", value: "ADM" },
  { name: "DOKUMEN KONTROL", value: "DOKUMEN KONTROL" },
  { name: "FINISHING", value: "FINISHING" },
  { name: "FINANCE", value: "FINANCE" },
  { name: "GUDANG & EKSPEDISI", value: "GUDANG & EKSPEDISI" },
  { name: "HRD", value: "HRD" },
  { name: "K3", value: "K3" },
  { name: "KEBERSIHAN", value: "KEBERSIHAN" },
  { name: "M Mesin", value: "M Mesin" },
  { name: "M Mold", value: "M Mold" },
  { name: "MR", value: "MR" },
  { name: "PRINTING", value: "PRINTING" },
  { name: "PPIC", value: "PPIC" },
  { name: "PRODUKSI", value: "PRODUKSI" },
  { name: "PURCHASING", value: "PURCHASING" },
  { name: "QC", value: "QC" },
  { name: "SECURITY", value: "Security" },
  { name: "TEKNISI", value: "TEKNISI" },
];

export const mock = [
  {
    itemId: "1",
    itemCheck: "Tekanan gas (jika ada)",
    standar: "Jarum pressure gauge pada posisi warma hijau",
  },
  {
    itemId: "2",
    itemCheck: "Kondisi Tabung",
    standar: "Tidak Karat",
  },
  {
    itemId: "3",
    itemCheck: "Kondisi segel",
    standar: "Tidak rusak",
  },
  {
    itemId: "4",
    itemCheck: "Kondisi selang, dan ujung semprot",
    standar: "Tidak retak, tidak patah, tidak pecah, dan masih lentur",
  },
  {
    itemId: "5",
    itemCheck: "Kondisi powder / bubuk",
    standar: "Tidak menggumpal (dikocok 5-6 kali)",
  },
  {
    itemId: "6",
    itemCheck: "Pin pengaman",
    standar: "Terpasang dengan baik",
  },
  {
    itemId: "7",
    itemCheck: "Posisi tanda APAR",
    standar: "Mudah terlihat / tidak terhalang",
  },
  {
    itemId: "8",
    itemCheck: "Posisi APAR",
    standar: "Mudah terlihat / tidak terhalang",
  },
  {
    itemId: "9",
    itemCheck: "Tanggal isi ulang",
    standar: "Lihat label APAR",
  },
  {
    itemId: "10",
    itemCheck: "Masa Kadaluarsa",
    standar: "Tidak kadaluarsa (lihat label masa kadaluarsa)",
  },
  {
    itemId: "11",
    itemCheck: "Kebersihan",
    standar: "Tidak berdebu (lap dengan kain)",
  },
  {
    itemId: "12",
    itemCheck: "Panduan penggunaan APAR",
    standar: "Terpasang dengan benar dan tidak rusak",
  },
  {
    itemId: "13",
    itemCheck: "Berat total APAR",
    standar: "",
  },
];

export const incomingApar = [
  {
    itemId: "1",
    itemCheck: "Tekanan gas",
    standar: "Baik",
  },
  {
    itemId: "2",
    itemCheck: "Bocor",
    standar: "Tidak",
  },
  {
    itemId: "3",
    itemCheck: "Kondisi tabung",
    standar: "Baik",
  },
  {
    itemId: "4",
    itemCheck: "Kondisi segel",
    standar: "Baik",
  },
  {
    itemId: "5",
    itemCheck: "Kondisi tangkai semprot",
    standar: "Baik",
  },
  {
    itemId: "6",
    itemCheck: "Kondisi selang semprot",
    standar: "Baik",
  },
  {
    itemId: "7",
    itemCheck: "Kondisi ujung semprot",
    standar: "Baik",
  },
  {
    itemId: "8",
    itemCheck: "Berat tabung APAR",
    standar: "",
  },
  {
    itemId: "9",
    itemCheck: "Berat isi APAR",
    standar: "",
  },
];

export const apar = [
  "1",
  "2",
  "3",
  "4",
  "5",
  "6",
  "7",
  "8",
  "9",
  "10",
  "11",
  "12",
  "13",
  "14",
  "15",
  "16",
  "17",
  "18",
  "19",
  "20",
  "21",
  "22",
  "23",
  "24",
  "25",
  "26",
  "27",
  "28",
  "29",
  "30",
  "31",
  "32",
  "33",
  "34",
  "35",
  "36",
  "37",
  "38",
  "39",
  "40",
  "41",
  "42",
  "43",
  "44",
  "45",
  "46",
  "47",
  "48",
  "49",
  "50",
];

export let constantChecklistPunching = [
  {
    id: "Ada Lubang",
    isChecked: false,
    isTrouble: false,
  },
  {
    id: "Tidak ada serabut",
    isChecked: false,
    isTrouble: false,
  },
  {
    id: "Jig masuk 100 %",
    isChecked: false,
    isTrouble: false,
  },
  {
    id: "Check Bending 5 Pcs",
    isChecked: false,
    isTrouble: false,
  },
  {
    id: "Check Sticker 5 Pcs",
    isChecked: false,
    isTrouble: false,
  },
];

export const sample = [
  {
    nama: "C.YBO(3)-MPC-YTZ4V-L-ST-6SE",
    dokumen: "MC 0320742",
    data: [
      {
        screen: "SMC-YTZ4V-L",
        dimensiPrint: {
          bawah: {
            ukuran: 63,
            toleransiAtas: 1,
            toleransiBawah: 1,
          },
          kanan: {
            ukuran: 13,
            toleransiAtas: 0,
            toleransiBawah: 0,
          },
          atas: {
            ukuran: 9,
            toleransiAtas: 0,
            toleransiBawah: 0,
          },
        },
      },
    ],
  },
  {
    nama: "C.YBO(3)-MPC-YTZ4V(W)-YMH4-ST-6SD",
    dokumen: "MC 0319228 A",
    data: [
      {
        screen: "SMC-YTZ4V(W)-YMH4",
        dimensiPrint: {
          bawah: {
            ukuran: 63,
            toleransiAtas: 1,
            toleransiBawah: 1,
          },
          kanan: {
            ukuran: 13,
            toleransiAtas: 0,
            toleransiBawah: 0,
          },
          atas: {
            ukuran: 9,
            toleransiAtas: 0,
            toleransiBawah: 0,
          },
        },
      },
    ],
  },
  {
    nama: "C.YBO(3)-MPC-YTZ5S(D)-L50A(N)-ST-6SD",
    dokumen: "MC 0320334 A",
    data: [
      {
        screen: "SMC-YTZ5S(D)-L50A(N)",
        dimensiPrint: {
          bawah: {
            ukuran: 63,
            toleransiAtas: 1,
            toleransiBawah: 1,
          },
          kanan: {
            ukuran: 13,
            toleransiAtas: 0,
            toleransiBawah: 0,
          },
          atas: {
            ukuran: 9,
            toleransiAtas: 0,
            toleransiBawah: 0,
          },
        },
      },
    ],
  },
  {
    nama: "C.YBO(3)-MPC-YTZ5S(W)-YMH4-ST-6SD",
    dokumen: "MC 0319229 A",
    data: [
      {
        screen: "SMC-YTZ5S(W)-YMH4",
        dimensiPrint: {
          bawah: {
            ukuran: 63,
            toleransiAtas: 1,
            toleransiBawah: 1,
          },
          kanan: {
            ukuran: 13,
            toleransiAtas: 0,
            toleransiBawah: 0,
          },
          atas: {
            ukuran: 9,
            toleransiAtas: 0,
            toleransiBawah: 0,
          },
        },
      },
    ],
  },
  {
    nama: "C.YBO(3)-MPC-YTZ6V-L-YT-26",
    dokumen: "MC 0315063",
    data: [
      {
        screen: "SMC-YTZ6V-L",
        dimensiPrint: {
          bawah: {
            ukuran: 81,
            toleransiAtas: 1,
            toleransiBawah: 1,
          },
          kiri: {},
          atas: {
            ukuran: 10,
          },
          kanan: {
            ukuran: 9,
            toleransiAtas: 0,
            toleransiBawah: 0,
          },
        },
        dimensiSticker: {
          bawah: {
            ukuran: 21,
            toleransiAtas: 1,
            toleransiBawah: 1,
          },
          kiri: {},
          atas: {},
          kanan: {
            ukuran: 9,
          },
        },
      },
    ],
  },
  {
    nama: "C.YBO(3)-MPC-YTZ6V(D)-L50A-ST-6SD",
    dokumen: "MC 0320793",
    data: [
      {
        screen: "SMC-YTZ6V(D)-L50A",
        dimensiPrint: {
          bawah: {
            ukuran: 82,
            toleransiAtas: 1,
            toleransiBawah: 1,
          },
          kanan: {
            ukuran: 9,
            toleransiAtas: 0,
            toleransiBawah: 0,
          },
          atas: {
            ukuran: 10,
            toleransiAtas: 0,
            toleransiBawah: 0,
          },
        },
      },
    ],
  },
  {
    nama: "C.YBO(3)-MPC-YTZ6V(W)-YMH4B-ST-6SD",
    dokumen: "MC 0319984 A",
    data: [
      {
        screen: "SMC-YTZ6V(W)-YMH4B",
        dimensiPrint: {
          bawah: {
            ukuran: 82,
            toleransiAtas: 1,
            toleransiBawah: 1,
          },
          kanan: {
            ukuran: 9,
            toleransiAtas: 0,
            toleransiBawah: 0,
          },
          atas: {
            ukuran: 10,
            toleransiAtas: 0,
            toleransiBawah: 0,
          },
        },
      },
    ],
  },
  {
    nama: "C.YBO(3)-MPC-YTZ6V-L-ST-6SE",
    dokumen: "MC 0320743",
    data: [
      {
        screen: "SMC-YTZ6V-L",
        dimensiPrint: {
          bawah: {
            ukuran: 82,
            toleransiAtas: 1,
            toleransiBawah: 1,
          },
          kanan: {
            ukuran: 9,
            toleransiAtas: 0,
            toleransiBawah: 0,
          },
          atas: {
            ukuran: 10,
            toleransiAtas: 0,
            toleransiBawah: 0,
          },
        },
      },
    ],
  },
  {
    nama: "C.YBO(3)-MPC-YTZ6V(W)-L50A-ST-6SD",
    dokumen: "MC 0320828",
    data: [
      {
        screen: "SMC-YTZ6V(W)-L50A",
        dimensiPrint: {
          bawah: {
            ukuran: 82,
            toleransiAtas: 1,
            toleransiBawah: 1,
          },
          kanan: {
            ukuran: 9,
            toleransiAtas: 0,
            toleransiBawah: 0,
          },
          atas: {
            ukuran: 10,
            toleransiAtas: 0,
            toleransiBawah: 0,
          },
        },
      },
    ],
  },
  {
    nama: "C.(3)-YB10L-A2-GY3",
    dokumen: "MC TIM 001",
    data: [
      {
        screen: "SMC-YB10L-A2-GY3",
        dimensiPrint: {
          bawah: {
            ukuran: 117,
            toleransiAtas: 1,
            toleransiBawah: 0.8,
          },
        },
      },
    ],
  },
  {
    nama: "C.(3)-MPC-12N5.5-4A-IEC-ST-IEC-CE2",
    dokumen: "MC 0314023 B",
    data: [
      {
        screen: "SMC-12N5,5-4A-IEC",
        dimensiPrint: {
          bawah: {
            ukuran: 86,
            toleransiAtas: 0.5,
            toleransiBawah: 0.5,
          },
          kanan: {
            ukuran: 13,
            toleransiAtas: 0,
            toleransiBawah: 0,
          },
          atas: {
            ukuran: 29,
            toleransiAtas: 0,
            toleransiBawah: 0,
          },
        },
      },
    ],
  },
  {
    nama: "C3MPC-12N5.5-4B-A-L50A-ST-6SD",
    dokumen: "MC 0320758",
    data: [
      {
        screen: "SMC-12N5,5-4B-A-L50A",
        dimensiPrint: {
          bawah: {
            ukuran: 86,
            toleransiAtas: 0.5,
            toleransiBawah: 0.5,
          },
          kanan: {
            ukuran: 13,
            toleransiAtas: 0,
            toleransiBawah: 0,
          },
          atas: {
            ukuran: 29,
            toleransiAtas: 0,
            toleransiBawah: 0,
          },
        },
        dimensiStiker: {
          kanan: {
            ukuran: 26,
            toleransiAtas: 0,
            toleransiBawah: 0,
          },
        },
      },
      {
        screen: "SMCS-12N5,5-4B-A-YU-5E",
        dimensiPrint: {
          bawah: {
            ukuran: 13,
            toleransiAtas: 0,
            toleransiBawah: 0,
          },
          kanan: {
            ukuran: 9,
            toleransiAtas: 0,
            toleransiBawah: 0,
          },
        },
      },
      {
        screen: "SMCB-12N5,5-4B-A-HV",
        dimensiPrint: {
          bawah: {
            ukuran: 26,
            toleransiAtas: 0,
            toleransiBawah: 0,
          },
          kanan: {
            ukuran: 28,
            toleransiAtas: 0,
            toleransiBawah: 0,
          },
        },
        dimensiStiker: {
          bawah: {
            ukuran: 28,
            toleransiAtas: 1,
            toleransiBawah: 1,
          },
          kanan: {
            ukuran: 26,
            toleransiAtas: 0,
            toleransiBawah: 0,
          },
        },
      },
    ],
  },
  {
    nama: "MPL-YTZ4V-YU-5YMH4",
    dokumen: "MC 0316132",
    data: [
      {
        screen: "SML-YTZ4V-YMH1",
        dimensiPrint: {
          kanan: {
            ukuran: 5,
            toleransiAtas: 0,
            toleransiBawah: 0,
          },
          atas: {
            ukuran: 13,
            toleransiAtas: 0,
            toleransiBawah: 0,
          },
        },
      },
    ],
  },
];

export const aspekQcdsm = {
  q: [
    {
      id: 1,
      keterangan: "Ada peningkatan kualitas pada tempat yang bersangkutan",
    },
    { id: 2, keterangan: "Peningkatan kualitas pada proses berikutnya" },
    {
      id: 3,
      keterangan: "Peningkatan kualitas pada proses sebelum dan berikutnya",
    },
    { id: 4, keterangan: "Peningkatan kualitas pada beberapa proses" },
    { id: 5, keterangan: "Peningkatan kualitas pada produk akhir" },
  ],

  c: [
    { id: 1, keterangan: "Cost < 10" },
    { id: 2, keterangan: "10 < Cost < 50" },
    { id: 3, keterangan: "50 < Cost < 100" },
    { id: 4, keterangan: "100 < Cost < 500" },
    { id: 5, keterangan: "Cost > 500" },
  ],

  d: [
    { id: 1, keterangan: "Dapat mencegah keterlambatan kecil" },
    { id: 2, keterangan: "Mengurangi keterlambatan s/d 1 hari" },
    { id: 3, keterangan: "Mengurangi keterlambatan s/d 5 hari" },
    { id: 4, keterangan: "Menghilangkan keterlambatan signifikan" },
    { id: 5, keterangan: "Proses menjadi sangat tepat waktu" },
  ],

  s_k3: [
    { id: 1, keterangan: "Dapat mencegah kecelakaan kecil" },
    { id: 2, keterangan: "Mencegah kecelakaan dengan absen s/d 1 hari" },
    { id: 3, keterangan: "Mencegah kecelakaan dengan absen s/d 5 hari" },
    { id: 4, keterangan: "Mencegah kecelakaan berat (cacat)" },
    { id: 5, keterangan: "Mencegah kecelakaan total" },
  ],

  s_lingkungan: [
    { id: 1, keterangan: "Mencegah pencemaran di area/stasiun kerja" },
    { id: 2, keterangan: "Mencegah pencemaran di area seksi" },
    { id: 3, keterangan: "Mencegah pencemaran di area perusahaan" },
    { id: 4, keterangan: "Mencegah pencemaran regional" },
    { id: 5, keterangan: "Mencegah pencemaran nasional/internasional" },
  ],

  m: [
    { id: 1, keterangan: "Meningkatkan komunikasi" },
    { id: 2, keterangan: "Meningkatkan kesadaran karyawan" },
    { id: 3, keterangan: "Meningkatkan disiplin karyawan" },
    { id: 4, keterangan: "Meningkatkan semangat kerja" },
    { id: 5, keterangan: "Meningkatkan produktivitas karyawan" },
  ],
};

export const rejectColumns = [
  { id: "Bubble", label: "Bubble" },
  { id: "Beda Warna", label: "Beda Warna" },
  { id: "Bekas Potong Gate", label: "Bekas Potong Gate" },
  { id: "Bergelombang", label: "Bergelombang" },
  { id: "Black / White Spot", label: "Black White Spot" },
  { id: "Bolong", label: "Bolong" },
  { id: "Burning", label: "Burning" },
  { id: "Ex Silicon", label: "Ex Silicon" },
  { id: "Crack / Fragile (Retak / Pecah)", label: "Crack" },
  { id: "Dimensi Pole Berubah / Deformasi", label: "Deformasi" },
  { id: "Flash", label: "Flash" },
  { id: "Flow Mark / Jetting", label: "Flow Mark" },
  { id: "Inject Kosong", label: "Inject Kosong" },
  { id: "Inject Double", label: "Inject Double" },
  {
    id: "Kabel / Pole Terbalik, kembar, kejepit",
    label: "Pole Terbalik, kembar, kejepit",
  },
  { id: "Kabut / Berawan", label: "Kabut" },
  { id: "Kurang Bahan / Unfill", label: "Unfill" },
  { id: "Lobdrok / Kepanasan", label: "Kepanasan" },
  { id: "Handle Tidak Lock", label: "Handle Tidak Lock" },
  { id: "Kotor", label: "Kotor" },
  { id: "Scratch / Baret", label: "Scratch / Baret" },
  { id: "Shink Mark", label: "Shink Mark" },
  { id: "Silver", label: "Silver" },
  {
    id: "Tanpa Timah / Kuningan / Connector / Kabel",
    label: "Tanpa Timah",
  },
  { id: "Timah Nongol", label: "Timah Nongol" },
  { id: "Weldline", label: "Weldline" },
  { id: "White Mark / Ejector Mark", label: "White Mark" },
  { id: "Bercak Timah", label: "Bercak Timah" },
  { id: "Nempel", label: "Nempel" },
  { id: "Garis Air", label: "Garis Air" },
  { id: "Bercak Silicon", label: "Bercak Silicon" },
  { id: "Oval", label: "Oval" },
  { id: "Ex Autosol", label: "Ex Autosol" },
  { id: "Ketarik", label: "Ketarik" },
  { id: "Setting Awal", label: "Setting Awal" },
  {
    id: "Setting Repair Mold/Mesin",
    label: "Setting Repair Mold/Mesin",
  },
  {
    id: "Re-setting Perbaikan",
    label: "Re-setting Perbaikan",
  },
  { id: "Cuci Warna", label: "Cuci Warna" },
  { id: "Ganti Warna", label: "Ganti Warna" },
  { id: "Over Cut", label: "Over Cut" },
  { id: "Salah Type", label: "Salah Type" },
  { id: "Timah Kembar", label: "Timah Kembar" },
  { id: "Tanpa Round Nut", label: "Tanpa Round Nut" },
  {
    id: "Dimensi Tidak Standard",
    label: "Dimensi Tidak Standard",
  },
  { id: "BBP Cacat", label: "BBP Cacat" },
  { id: "Cacat Cosmetic", label: "Cacat Cosmetic" },
  { id: "Bending", label: "Bending" },
  { id: "Keriput", label: "Keriput" },
  { id: "Karantina", label: "Karantina" },
  { id: "Pilih Alasan", label: "Tidak di isi" },
];

export const CATEGORY_CONFIG = [
  {
    key: "SettingAwalPR",
    label: "Setting Awal PR",
    id: "Setting Awal",
    bagian: "PR",
    bagianSource: "outer",
  },
  {
    key: "PrintingBedaWarna",
    label: "Printing Beda Warna",
    id: "Printing beda warna",
  },
  { key: "PrintingMelebar", label: "Printing Melebar", id: "Printing melebar" },
  {
    key: "PrintingPutusPutus",
    label: "Printing Putus Putus",
    id: "Printing Putus-Putus",
  },
  {
    key: "PrintingTidakRata",
    label: "Printing Tidak Rata",
    id: "Printing tidak rata",
  },
  { key: "PrintingGeser", label: "Printing Geser", id: "Printing geser" },
  { key: "PrintingDouble", label: "Printing Double", id: "Printing double" },
  { key: "HurufMengecil", label: "Huruf Mengecil", id: "Huruf mengecil" },
  { key: "PrintingScratch", label: "Printing Scratch", id: "Printing Scratch" },
  { key: "PrintingMiring", label: "Printing Miring", id: "Printing miring" },
  {
    key: "PrintingTerkelupas",
    label: "Printing Terkelupas",
    id: "Printing Terkelupas",
  },
  {
    key: "PrintingTidakLengkap",
    label: "Printing Tidak Lengkap",
    id: "Printing tidak lengkap",
  },
  {
    key: "SalahTypePrinting",
    label: "Salah Type Printing",
    id: "Salah type printing",
  },
  {
    key: "PrintingSalahPosisi",
    label: "Printing Salah Posisi",
    id: "Printing salah posisi",
  },
  {
    key: "BaretPR",
    label: "Baret PR",
    id: "Baret",
    bagian: "PR",
    bagianSource: "outer",
  },
  {
    key: "DeformasiPR",
    label: "Deformasi PR",
    id: "Deformasi",
    bagian: "PR",
    bagianSource: "outer",
  },
  {
    key: "LubangTdkCenter",
    label: "Lubang Tdk Center",
    id: "Lubang tdk center",
  },
  {
    key: "LubangBerserabut",
    label: "Lubang Berserabut",
    id: "Lubang berserabut",
  },
  {
    key: "BurningSP",
    label: "Burning SP",
    id: "Burning",
    bagian: "SP",
    bagianSource: "item",
  },
  {
    key: "CrackSP",
    label: "Crack SP",
    id: "Crack",
    bagian: "SP",
    bagianSource: "item",
  },
  { key: "CacatKosmetik", label: "Cacat Kosmetik", id: "Cacat Kosmetik" },
  {
    key: "OverCutSP",
    label: "Over Cut SP",
    id: "Over Cut",
    bagian: "SP",
    bagianSource: "item",
  },
  { key: "HandleTerangkat", label: "Handle Terangkat", id: "Handle Terangkat" },
  {
    key: "DeformasiSP",
    label: "Deformasi SP",
    id: "Deformasi",
    bagian: "SP",
    bagianSource: "item",
  },
  { key: "Scratch", label: "Scratch", id: "Scratch" },
  {
    key: "SettingAwalSP",
    label: "Setting Awal SP",
    id: "Setting Awal",
    bagian: "SP",
    bagianSource: "item",
  },
  { key: "Kusam", label: "Kusam", id: "Kusam" },
  { key: "Bubble", label: "Bubble", id: "Bubble" },
  { key: "BedaWarna", label: "Beda Warna", id: "Beda Warna" },
  {
    key: "BekasPotongGate",
    label: "Bekas potongan gate",
    id: "Bekas Potong Gate",
  },
  { key: "Bergelombang", label: "Bergelombang", id: "Bergelombang" },
  {
    key: "BlackWhiteSpot",
    label: "Black Spot/White Spot",
    id: "Black / White Spot",
  },
  { key: "Bolong", label: "Bolong", id: "Bolong" },
  { key: "Burning", label: "Burning", id: "Burning" },
  { key: "ExSilicon", label: "Ex Silicon", id: "Ex Silicon" },
  {
    key: "Crack",
    label: "Crack/Fragile (retak/pecah)",
    id: "Crack / Fragile (Retak / Pecah)",
  },
  {
    key: "Deformasi",
    label: "Dimensi pole berubah/Deformasi",
    id: "Dimensi Pole Berubah / Deformasi",
  },
  { key: "Flash", label: "Flash", id: "Flash" },
  { key: "FlowMark", label: "Flow Mark/Jetting", id: "Flow Mark / Jetting" },
  { key: "InjectKosong", label: "Inject Kosong", id: "Inject Kosong" },
  { key: "InjectDouble", label: "Inject Double", id: "Inject Double" },
  {
    key: "PoleTerbalik",
    label: "Kabel/Pole terbalik kembar kejepit",
    id: "Kabel / Pole Terbalik, kembar, kejepit",
  },
  { key: "Kabut", label: "Kabut/Berawan", id: "Kabut / Berawan" },
  { key: "Unfill", label: "Kurang bahan/Unfill", id: "Kurang Bahan / Unfill" },
  { key: "Kepanasan", label: "Lobdrok/Kepanasan", id: "Lobdrok / Kepanasan" },
  {
    key: "HandleTidakLock",
    label: "Handle Tidak Lock",
    id: "Handle Tidak Lock",
  },
  { key: "Kotor", label: "Kotor", id: "Kotor" },
  { key: "Baret", label: "Scratch/Baret", id: "Scratch / Baret" },
  { key: "ShinkMark", label: "Shink Mark", id: "Shink Mark" },
  { key: "Silver", label: "Silver", id: "Silver" },
  {
    key: "TanpaTimah",
    label: "Tanpa timah/Kuningan/ Conector/ Kabel",
    id: "Tanpa Timah / Kuningan / Connector / Kabel",
  },
  { key: "OffIstrahat", label: "Off Istrahat", id: "Off Istirahat" },
  {
    key: "SettingRepair",
    label: "Setting Repair Mold/Mesin",
    id: "Setting Repair Mold/Mesin",
  },
  {
    key: "ReSettingPerbaikan",
    label: "Re-setting Perbaikan",
    id: "Re-setting Perbaikan",
  },
  { key: "TimahNongol", label: "Timah Nongol", id: "Timah Nongol" },
  { key: "Weldline", label: "Weldline", id: "Weldline" },
  {
    key: "WhiteMark",
    label: "White Mark/ Ejector Mark",
    id: "White Mark / Ejector Mark",
  },
  { key: "BercakTimah", label: "Bercak Timah", id: "Bercak Timah" },
  { key: "Nempel", label: "Nempel", id: "Nempel" },
  { key: "GarisAir", label: "Garis Air", id: "Garis Air" },
  { key: "BercakSilicon", label: "Bercak Slicon", id: "Bercak Silicon" },
  { key: "Oval", label: "Oval", id: "Oval" },
  { key: "ExAutosol", label: "EX AUTOSOL ", id: "Ex Autosol" },
  { key: "Ketarik", label: "KETARIK", id: "Ketarik" },
  { key: "SettingAwal", label: "Setting Awal", id: "Setting Awal" },
  { key: "CuciWarna", label: "Cuci Warna", id: "Cuci Warna" },
  { key: "GantiWarna", label: "Ganti Warna", id: "Ganti Warna" },
  { key: "OverCut", label: "Over Cut", id: "Over Cut" },
  { key: "SalahType", label: "Salah Type", id: "Salah Type" },
  { key: "TimahKembar", label: "Timah Kembar", id: "Timah Kembar" },
  { key: "TanpaRoundNut", label: "Tanpa Round Nut", id: "Tanpa Round Nut" },
  {
    key: "DimensiTidakStandard",
    label: "Dimensi Tidak Standard",
    id: "Dimensi Tidak Standard",
  },
  { key: "BBPCacat", label: "BBP Cacat", id: "BBP Cacat" },
  { key: "CacatCosmetic", label: "Cacat Cosmetic", id: "Cacat Cosmetic" },
  { key: "Bending", label: "Bending", id: "Bending" },
  { key: "Keriput", label: "Keriput", id: "Keriput" },
];

export const REPAIR_CATEGORY_CONFIG = [
  { key: "HurufMengecilRepair", label: "Huruf Mengecil", id: "Huruf Mengecil" },
  {
    key: "HurufPutusPutus",
    label: "Huruf Putus-Putus",
    id: "Huruf Putus-Putus",
  },
  {
    key: "PrintingDoubleRepair",
    label: "Printing Double",
    id: "Printing Double",
  },
  { key: "PrintingGeserRepair", label: "Printing Geser", id: "Printing Geser" },
  { key: "PrintingMeleber", label: "Printing Meleber", id: "Printing Meleber" },
  {
    key: "PrintingMiringRepair",
    label: "Printing Miring",
    id: "Printing Miring",
  },
  {
    key: "PrintingTergores",
    label: "Printing Tergores",
    id: "Printing Tergores",
  },
  {
    key: "PrintingTerkelupasRepair",
    label: "Printing Terkelupas",
    id: "Printing Terkelupas",
  },
  {
    key: "PrintingTidakSempurna",
    label: "Printing Tidak Sempurna",
    id: "Printing Tidak Sempurna",
  },
  { key: "PunchingRepair", label: "Punching", id: "Punching" },
  { key: "SettingAwalRepair", label: "Setting Awal", id: "Setting Awal" },

  { key: "SalahPrintingRepair", label: "Salah Printing", id: "Salah Printing" },
  { key: "WarnaPrintingRepair", label: "Warna Printing", id: "Warna Printing" },

  {
    key: "PrintingBedaWarnaRepair",
    label: "Printing Beda Warna",
    id: "Printing beda warna",
  },
  {
    key: "PrintingMelebarRepair",
    label: "Printing Melebar",
    id: "Printing melebar",
  },
  {
    key: "PrintingPutusPutusRepair",
    label: "Printing Putus-Putus",
    id: "Printing Putus-Putus",
  },
  {
    key: "PrintingTidakRataRepair",
    label: "Printing Tidak Rata",
    id: "Printing tidak rata",
  },
  {
    key: "PrintingGeserTim2Repair",
    label: "Printing Geser (Tim 2)",
    id: "Printing geser",
  },
  {
    key: "PrintingDoubleTim2Repair",
    label: "Printing Double (Tim 2)",
    id: "Printing double",
  },
  {
    key: "HurufMengecilTim2Repair",
    label: "Huruf Mengecil (Tim 2)",
    id: "Huruf mengecil",
  },
  {
    key: "PrintingScratchRepair",
    label: "Printing Scratch",
    id: "Printing Scratch",
  },
  {
    key: "PrintingMiringTim2Repair",
    label: "Printing Miring (Tim 2)",
    id: "Printing miring",
  },
  {
    key: "PrintingTidakLengkapRepair",
    label: "Printing Tidak Lengkap",
    id: "Printing tidak lengkap",
  },
  {
    key: "SalahTypePrintingRepair",
    label: "Salah Type Printing",
    id: "Salah type printing",
  },
  {
    key: "PrintingSalahPosisiRepair",
    label: "Printing Salah Posisi",
    id: "Printing salah posisi",
  },
  { key: "BaretRepair", label: "Baret", id: "Baret" },
  { key: "DeformasiRepair", label: "Deformasi", id: "Deformasi" },
  {
    key: "LubangTdkCenterRepair",
    label: "Lubang Tdk Center",
    id: "Lubang tdk center",
  },
  {
    key: "LubangBerserabutRepair",
    label: "Lubang Berserabut",
    id: "Lubang berserabut",
  },
];
